import { objectSchemaOf, Joi } from '../helpers';

export interface IUser {
  uid: string;
  email: string;
  displayName: string;
  organisationId?: string;
  createdOn: number;
  isConsole?: boolean;
  isHil?: boolean;
  isAdmin?: boolean;
  avatar?: string;
  notifyIfOffline?: boolean;
}

export const userSchema = objectSchemaOf<IUser>({
  email: Joi.string().required(),
  uid: Joi.string().required(),
  displayName: Joi.string().required(),
  organisationId: Joi.string().optional(),
  createdOn: Joi.number().required(),
  isConsole: Joi.boolean().optional(),
  isHil: Joi.boolean().optional(),
  isAdmin: Joi.boolean().optional(),
  avatar: Joi.string().optional(),
  notifyIfOffline: Joi.boolean().optional(),
});
